import React from "react";

import { Loader } from "../../../common/loader";
import classes from "./styles.scss";

function RouteLoader() {
  return (
    <div className={classes.routeLoader}>
      <div className={classes.loader}>
        <Loader />
      </div>
    </div>
  );
}

export { RouteLoader };
